import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import HomePage from './HomePage'
import DeactivatedOrgPage from './DeactivatedOrgPage'

export default function RouterHub() {
	const user = useSelector((s) => s.user.authUser)
	const currentOrg = useSelector((s) => s.user.currentOrg)
	const currentExperience = useSelector((s) => s.user.currentExperience)
	const role = useSelector((state) => state.org.orgRole)
	const userPositions = useSelector((state) => state.org.userPositions || [])
	const currentOrgSlug = currentOrg?.orgSlug || ''

	if (!user) return null

	if (currentOrg?.isActive === false) return <DeactivatedOrgPage />

	if (!role) return null

	if (user.userType === 'superAdmin')
		return <Navigate to='/control/orgs' replace />

	if (role === 'admin' && currentOrgSlug)
		return <Navigate to={`/${currentOrgSlug}/admin/experiences`} replace />

	const firstActivePosition = (userPositions || []).find(
		(position) =>
			position?.experienceSlug && position?.experienceStatus !== 'inactive',
	)
	const resolvedExperienceSlug =
		currentExperience?.slug || firstActivePosition?.experienceSlug || ''

	if (resolvedExperienceSlug && currentOrgSlug)
		return (
			<Navigate
				to={`/${currentOrgSlug}/experiences/${resolvedExperienceSlug}`}
				replace
			/>
		)

	if (currentOrgSlug) return <HomePage orgSlug={currentOrgSlug} />

	return null
}
